import styled from 'styled-components';

export const StyledSpinner = styled.div`
  display: flex;
  justify-content: center;
  margin: 15px;

  .fade-in {
    -webkit-animation: fade-in 2s cubic-bezier(0.39, 0.575, 0.565, 1) both infinite;
    animation: fade-in 2s cubic-bezier(0.39, 0.575, 0.565, 1) both infinite;
  }

  @-webkit-keyframes fade-in {
    0% {
      opacity: 0;
    }

    10% {
      opacity: 0;
    }

    40% {
      opacity: 1;
    }
  }
  @keyframes fade-in {
    0% {
      opacity: 0;
    }
    10% {
      opacity: 0;
    }
    40% {
      opacity: 1;
    }
  }

  .fade-in2 {
    -webkit-animation: fade-in2 2s cubic-bezier(0.39, 0.575, 0.565, 1) both infinite;
    animation: fade-in2 2s cubic-bezier(0.39, 0.575, 0.565, 1) both infinite;
  }

  @-webkit-keyframes fade-in2 {
    0% {
      opacity: 0;
    }
    20% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
  }
  @keyframes fade-in2 {
    0% {
      opacity: 0;
    }
    20% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
  }

  .fade-in3 {
    -webkit-animation: fade-in3 2s cubic-bezier(0.39, 0.575, 0.565, 1) both infinite;
    animation: fade-in3 2s cubic-bezier(0.39, 0.575, 0.565, 1) both infinite;
  }

  @-webkit-keyframes fade-in3 {
    0% {
      opacity: 0;
    }
    30% {
      opacity: 0;
    }
    60% {
      opacity: 1;
    }
  }
  @keyframes fade-in3 {
    0% {
      opacity: 0;
    }
    30% {
      opacity: 0;
    }
    60% {
      opacity: 1;
    }
  }

  .fade-in4 {
    -webkit-animation: fade-in4 2s cubic-bezier(0.39, 0.575, 0.565, 1) both infinite;
    animation: fade-in4 2s cubic-bezier(0.39, 0.575, 0.565, 1) both infinite;
  }

  @-webkit-keyframes fade-in4 {
    0% {
      opacity: 0;
    }
    32% {
      opacity: 0;
    }
    62% {
      opacity: 1;
    }
  }
  @keyframes fade-in4 {
    0% {
      opacity: 0;
    }
    32% {
      opacity: 0;
    }
    62% {
      opacity: 1;
    }
  }

  .fade-in5 {
    -webkit-animation: fade-in5 2s cubic-bezier(0.39, 0.575, 0.565, 1) both infinite;
    animation: fade-in5 2s cubic-bezier(0.39, 0.575, 0.565, 1) both infinite;
  }

  @-webkit-keyframes fade-in5 {
    0% {
      opacity: 0;
    }
    34% {
      opacity: 0;
    }
    64% {
      opacity: 1;
    }
  }
  @keyframes fade-in5 {
    0% {
      opacity: 0;
    }
    34% {
      opacity: 0;
    }
    64% {
      opacity: 1;
    }
  }

  .scale-out-center {
    -webkit-animation: scale-out-center 2s cubic-bezier(0.55, 0.085, 0.68, 0.53) infinite;
    animation: scale-out-center 2s cubic-bezier(0.55, 0.085, 0.68, 0.53) infinite;
  }

  @-webkit-keyframes scale-out-center {
    0% {
      -webkit-transform: scale(1);
      transform: scale(1);
      opacity: 1;
    }

    50% {
      -webkit-transform: scale(1);
      transform: scale(1);
      opacity: 1;
    }

    100% {
      -webkit-transform: scale(0);
      transform: scale(0);
      opacity: 1;
    }
  }
  @keyframes scale-out-center {
    0% {
      -webkit-transform: scale(1);
      transform: scale(1);
      opacity: 1;
    }

    80% {
      -webkit-transform: scale(1);
      transform: scale(1);
      opacity: 1;
    }

    100% {
      -webkit-transform: scale(0);
      transform: scale(0);
      opacity: 1;
    }
  }

  .logo-cont {
    position: relative;
  }
  .shape1 {
    width: 132.3%;
    height: 82%;
    top: 0;
    left: -10%;
    position: absolute;
    clip-path: polygon(7.7% 35.2%, 45% 0%, 45% 24.2%, 20.6% 47%);
    background: #24b3b8;
  }
  .shape2 {
    width: 54.8%;
    height: 108%;
    top: 28.9%;
    left: -24.9%;
    position: absolute;
    clip-path: polygon(46% 0%, 77% 9%, 77% 43.6%, 46% 53%);
    background: #f7b600;
  }
  .shape3 {
    width: 49%;
    height: 65%;
    top: -0.6%;
    left: 49%;
    position: absolute;
    clip-path: polygon(0% 1%, 101% 45%, 66% 61%, 0% 31%);
    background: #22397b;
  }
  .shape4 {
    width: 33%;
    height: 57%;
    top: 19.7%;
    left: 49%;
    position: absolute;
    clip-path: polygon(0% 0%, 99% 34%, 99% 99.5%, 0% 66%);
    background: #ffda00;
  }
  .shape5 {
    width: 65%;
    height: 38%;
    top: 57.3%;
    left: 17.2%;
    position: absolute;
    clip-path: polygon(50% 0%, 100% 50%, 50% 100%, 0 50%);
    background: #e73558;
  }
`;
